import {useMemo} from 'react';

import {WbAgentClient} from './WbAgentClient';

/**
 * Resolve the WB Agent base URL from the global config.
 *
 * The wb_agent service runs on its own port (default 8090 in dev).
 * Reads from window.CONFIG.WB_AGENT_BASE_URL, which is wired through:
 *   development.env -> env.template.js -> env.js -> window.CONFIG
 */
const resolveWbAgentBaseUrl = (): string | null => {
  const url = (window as any)?.CONFIG?.WB_AGENT_BASE_URL;
  if (url && typeof url === 'string' && url.length > 0) {
    return url.replace(/\/+$/, '');
  }
  return null;
};

export const useWbAgentClient = (
  entity?: string,
  project?: string
): WbAgentClient | null => {
  const maybeBaseUrl = resolveWbAgentBaseUrl();
  return useMemo(() => {
    if (!maybeBaseUrl) {
      return null;
    }
    return new WbAgentClient({baseUrl: maybeBaseUrl, entity, project});
  }, [maybeBaseUrl, entity, project]);
};
